var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ICCEventBusManager } from '@idp/event-bus';
import { history } from '@idp/routables';
import { withStore } from '@idp/state-manager';
import getTestId from '@idp/ui-components/utils';
import * as React from 'react';
import { StateProvider } from '../../services/state-provider';
import PriceBarContainerState from './PriceBar.container.state';
import Api from '@idse/checkout-ui/api/Api';
import NativeServices from '@idse/checkout-ui/utils/NativeServices';
import * as checkoutUtils from '@idse/checkout-ui/utils/UtilityFunctions';
import * as cartUtils from '@idse/cart-ui/utils/CartUtilFunctions';
import { Networker } from '@idp/networker';
import * as offerStyles from './../Offer/Offer.container.scss';
import { LobStateManagerNameSpaces, RouteUrlTypes, CatalogDataType } from '../MainView/MainView.container.props';
import { ButtonColor, ButtonType } from '@idp/ui-components/components/atoms/Button/ButtonProps';
import { ModalSizes } from '@idp/ui-components/components/atoms/Modal/ModalProps';
import PriceBar from './PriceBarSub/PriceBar';
import { CMS } from '@idp/cms-integration';
import { CMSFeedMap } from '../MainView/MainViewMaps';
import { getCatalogDataType, isPrepaidTaxCalculated, isEmptyObject, utilFetchCRT, onCartIsTaxCalculated, fireSystemEvent, setFlowCodeandProductTypeValues, reportPageLoad, isIxpCheckoutFeatureEnabled } from '../../utils/UtilityFunctions';
import Events from '../UserInteractionFramework/Events';
import Loader from '../../utils/UtilityFunctions';
import { EventEmitter } from 'events';
import * as cartUtilityFunction from '@idse/cart-ui/utils/UtilityFunctions';
import { Modal } from '@idp/ui-components';
import * as styles from './../Cart/Cart.container.scss';
import Button from '@idp/ui-components/components/atoms/Button/';
import ReportingService from '@idse/checkout-ui/api/ReportingService';
import { LinkPositionDataKeysOptions, EventActions, ErrorTypeOption, SuccessFlags } from '../../services/AnalyticsEvents';
import ReportingGateway from '../../services/ReportingGateway';
var CHECKOUT_PAGE_URL = '/buy/checkout/checkoutview';
var BUY_CART_PAGE_URL = '/buy/cart/';
var UPSELL_INTERSTITAL_PAGE_URL = '/buy/wireless/upsell-offer-interstitial';
var buttonText = 'Go to cart';
var goBackApplyBenefitBtnText = 'Go back & apply benefit';
var checkoutWithoutBenefitBtnText = 'Check out without benefit';
var APPLE_PAY_ERROR = 'appleNativeError';
var PriceBarContainer = /** @class */ (function (_super) {
    __extends(PriceBarContainer, _super);
    function PriceBarContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.cartUpdateTotals = '';
        _this.checkoutApi = new Api();
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.networker = new Networker();
        _this.state = new PriceBarContainerState();
        _this.loader = new Loader();
        _this.eventEmitter = new EventEmitter();
        _this.getPriceBarData = _this.getPriceBarData.bind(_this);
        _this.getPriceBarDataForLobs = _this.getPriceBarDataForLobs.bind(_this);
        _this.onPriceClick = _this.onPriceClick.bind(_this);
        _this.registerToPriceChanges = _this.registerToPriceChanges.bind(_this);
        _this.updateState = _this.updateState.bind(_this);
        _this.getClearedLobPrice = _this.getClearedLobPrice.bind(_this);
        _this.getShowPriceBar = _this.getShowPriceBar.bind(_this);
        _this.preChecksForCheckoutActions = _this.preChecksForCheckoutActions.bind(_this);
        _this.getOrderConfirmURL = _this.getOrderConfirmURL.bind(_this);
        _this.showACPVerificationModal = _this.showACPVerificationModal.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        _this.onApplyBenifit = _this.onApplyBenifit.bind(_this);
        _this.onCheckOut = _this.onCheckOut.bind(_this);
        _this.reportAcpModalPageLoad = _this.reportAcpModalPageLoad.bind(_this);
        _this.getCartStateValue = _this.getCartStateValue.bind(_this);
        _this.eapCancelButtonHandler = _this.eapCancelButtonHandler.bind(_this);
        _this.fetchOnDeviceEncryptToken = _this.fetchOnDeviceEncryptToken.bind(_this);
        _this.reportingService = new ReportingService();
        _this.cartUpdateTotals = _this.getCartStateValue();
        return _this;
    }
    PriceBarContainer.prototype.componentDidMount = function () {
        this.registerToPriceChanges();
        this.getClearedLobPrice('ClearLobData');
    };
    PriceBarContainer.prototype.constructFullUrl = function (path) {
        if (path.includes('http')) {
            return path;
        }
        return window.location.origin + path;
    };
    PriceBarContainer.prototype.getInitialCartPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, initialPrice, cartState, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.networker.get('/msapi/cart/v1/priceInfo')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        initialPrice = _a.sent();
                        if (initialPrice.error || !initialPrice.content.status ||
                            initialPrice.content.status.toLowerCase() !== 'success') {
                            return [2 /*return*/];
                        }
                        cartState = initialPrice.content.payload.priceInfo.orderPriceInfo;
                        this.setState({
                            cartState: {
                                dueMonthly: cartState.dueMonthly,
                                dueOneTime: cartState.dueOneTime,
                                dueToday: cartState.dueToday,
                                enablepriceBarZeroAmount: cartState.enablepriceBarZeroAmount,
                                isAmtProvidedTaxInclusive: cartState.isAmtProvidedTaxInclusive,
                                readyToCheckout: false,
                            },
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // TODO: switch to logger once it's available.
                        console.error("error retrieving initial price: " + error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PriceBarContainer.prototype.logDataToElk = function (logCode, logMsg, logStack, pageUrl) {
        var _a;
        if (logCode === void 0) { logCode = ''; }
        if (logMsg === void 0) { logMsg = ''; }
        if (logStack === void 0) { logStack = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var LOG_URL;
            return __generator(this, function (_b) {
                LOG_URL = '/buy/shoppingcart/log-error/';
                try {
                    fetch(LOG_URL, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            logCode: logCode,
                            logMsg: logMsg,
                            logStack: logStack,
                            pageUrl: pageUrl || ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href),
                        }),
                    });
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    PriceBarContainer.prototype.getNewUpsellApiData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var serviceURL, postData, response, res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.showLoader();
                        serviceURL = '/msapi/onlinesalesorch/v1/interstitialoffer/';
                        postData = this.generateNewUpsellCartApiRequest();
                        if (!!isEmptyObject(postData)) return [3 /*break*/, 8];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, new Networker().post(serviceURL, postData, utilFetchCRT())];
                    case 2:
                        response = _a.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.ok)) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        res = _a.sent();
                        this.stateManager.set('upSellPageDetails', { response: res });
                        return [2 /*return*/, res];
                    case 4:
                        this.handleUpSellFailure();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this.handleUpSellFailure();
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.handleUpSellFailure();
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PriceBarContainer.prototype.handleUpSellFailure = function () {
        this.loader.hideLoader();
        window.sessionStorage.removeItem('WIRELESS:newUpSellCartApi');
        this.onPriceClick();
    };
    PriceBarContainer.prototype.generateNewUpsellCartApiRequest = function () {
        // tslint:disable-next-line:no-any
        var postData = this.stateManager.get('WIRELESS', 'selectedDeviceForUpsell');
        return postData === null || postData === void 0 ? void 0 : postData.device;
    };
    PriceBarContainer.prototype.registerToPriceChanges = function () {
        var _this = this;
        var lobList = LobStateManagerNameSpaces;
        lobList.forEach(function (lob) {
            var observer = {
                eventHandler: function () { _this.updateState(lob); },
                observerId: ICCEventBusManager.getUUID(),
                serviceName: lob + ':priceBarUpdate',
            };
            ICCEventBusManager.getInstance().registerObserver(observer);
        });
    };
    PriceBarContainer.prototype.getCartStateValue = function (lob) {
        var cartState = this.stateManager.get(lob ? lob : 'CART', 'priceBarUpdate');
        if (!cartState) {
            return '';
        }
        return 'dueMonthly=' + cartState.dueMonthly +
            ',dueOneTime=' + cartState.dueOneTime + 'dueToday=' + cartState.dueToday;
    };
    PriceBarContainer.prototype.updateState = function (lob) {
        var localCartState = this.getCartStateValue(lob);
        if (localCartState && (this.cartUpdateTotals !== localCartState)) {
            // this.updateGNAVCart();
            this.cartUpdateTotals = localCartState;
        }
        var cartState = this.stateManager.get(lob ? lob : 'CART', 'priceBarUpdate');
        this.stateManager.set('pbData', cartState);
        this.setState({
            cartState: cartState,
        });
    };
    // added for Global Nav
    PriceBarContainer.prototype.updateGNAVCart = function () {
        var qry = document.querySelector('attwc-globalnav-idp-cart');
        if (qry) {
            var event_1 = document.createEvent('Event');
            event_1.initEvent('getCartUpdate', true, true);
            qry.dispatchEvent(event_1);
        }
    };
    PriceBarContainer.prototype.resetButtonState = function (rchkt) {
        var _this = this;
        if (rchkt === void 0) { rchkt = false; }
        this.setState(function () { return ({
            cartState: {
                directToCheckout: _this.state.cartState.directToCheckout,
                dueMonthly: _this.state.cartState.dueMonthly,
                dueOneTime: _this.state.cartState.dueOneTime,
                dueToday: _this.state.cartState.dueToday,
                enablepriceBarZeroAmount: _this.state.cartState.enablepriceBarZeroAmount,
                isAmtProvidedTaxInclusive: _this.state.cartState.isAmtProvidedTaxInclusive,
                readyToCheckout: rchkt,
            },
        }); });
    };
    PriceBarContainer.prototype.resetPBData = function (buttonLabel, enableCheckout) {
        this.stateManager.set('pbData', {
            buttonLabel: buttonLabel,
            directToCheckout: this.state.cartState.directToCheckout,
            dueMonthly: this.state.cartState.dueMonthly,
            dueOneTime: this.state.cartState.dueOneTime,
            dueToday: this.state.cartState.dueToday,
            enablepriceBarZeroAmount: this.state.cartState.enablepriceBarZeroAmount,
            isAmtProvidedTaxInclusive: this.state.cartState.isAmtProvidedTaxInclusive,
            readyToCheckout: enableCheckout ? true : false,
        });
    };
    PriceBarContainer.prototype.getClearedLobPrice = function (lobData) {
        var _this = this;
        var cartState = this.stateManager.get(lobData, 'ClearLobData');
        this.setState(function () { return ({
            cartState: {
                directToCheckout: _this.state.cartState.directToCheckout,
                dueMonthly: _this.state.cartState.dueMonthly,
                dueOneTime: _this.state.cartState.dueOneTime,
                dueToday: _this.state.cartState.dueToday,
                enablepriceBarZeroAmount: _this.state.cartState.enablepriceBarZeroAmount,
                isAmtProvidedTaxInclusive: _this.state.cartState.isAmtProvidedTaxInclusive,
                readyToCheckout: false,
            },
        }); });
    };
    PriceBarContainer.prototype.onSubmitOrderDetails = function () {
        var _this = this;
        var pbData = this.props.pbDataStore;
        var buttonLabel = pbData && pbData.buttonLabel;
        if (buttonLabel && buttonLabel.toLowerCase().indexOf('apple pay') > -1) {
            var applePayStatus = this.stateManager.get('CHECKOUT', 'applePayStatus');
            this.events = new Events([APPLE_PAY_ERROR]);
            if (applePayStatus && applePayStatus.merchantId) {
                NativeServices.getInstance().invokeApplePay({
                    errorCallback: function (error) {
                        _this.stateManager.set('submitOrder', { orderSubmitted: false });
                        _this.events.fireEvent({
                            errorCode: error.statusCode,
                            errorString: error.errorString,
                        }, APPLE_PAY_ERROR);
                        console.error(error);
                    },
                    invokeApplePaySuccess: function (response) {
                        var isValidResponse = response && response.statusCode === 0
                            && response.paymentMethod && response.paymentMethod.network
                            && response.billingContact
                            && response.billingContact.postalAddress
                            && response.billingContact.postalAddress.postalCode
                            && response.billingContact.name
                            && response.paymentData;
                        if (isValidResponse) {
                            NativeServices.getInstance()
                                .debugApplePay('ValidResponse Received and now prceeding to submitOrder', true);
                            var familyName = response.billingContact.name.familyName.replace(/[^\w\s]/gi, '');
                            var applePayData = {
                                billingAddress: {
                                    zipCode: response.billingContact.postalAddress.postalCode,
                                },
                                cardHolderName: response.billingContact.name.givenName
                                    + ' ' + familyName,
                                network: response.paymentMethod.network,
                                paymentData: response.paymentData,
                            };
                            sessionStorage.setItem('CHECKOUT:applePayData', JSON.stringify(applePayData));
                            _this.processOrder(applePayData);
                        }
                        else if (response.statusCode === 1) {
                            NativeServices.getInstance().
                                debugApplePay('PriceBarContainer:: User cancelled the apple pay', true);
                            _this.stateManager.set('submitOrder', { orderSubmitted: false });
                        }
                        else {
                            NativeServices.getInstance().debugApplePay('PriceBarContainer::Unexpected Apple Pay response from Native Service', true);
                            NativeServices.getInstance().debugApplePay(response);
                            _this.stateManager.set('submitOrder', { orderSubmitted: false });
                        }
                    },
                }, pbData.dueToday.toString(), applePayStatus.merchantId);
            }
            else {
                NativeServices.getInstance()
                    .debugApplePay('PriceBarContainer::Merchant ID missing for ApplePay!!!');
                this.logDataToElk('APPLE_PAY_PAYMENT_MECH_MISS', 'Merchant ID missing for ApplePay!!!', {});
            }
        }
        else {
            this.processOrder();
        }
    };
    PriceBarContainer.prototype.getActionText = function (cmsData, cartState) {
        cmsData = cmsData || {};
        var actionText = buttonText;
        var urlPath = history.location.pathname;
        var arrayUrl = urlPath.split('/');
        this.isExpressUpgrade = false;
        switch (arrayUrl[1]) {
            case 'checkout':
                this.isExpressUpgrade = checkoutUtils.isExpressUpgradeViewEnabled();
                if (cartState && cartState.buttonLabel && cartState.buttonLabel.length > 0) {
                    actionText = cartState.buttonLabel;
                }
                else {
                    actionText = cmsData.submitOrderCTAText || 'Submit order';
                }
                return actionText;
            case 'cart':
                actionText = cmsData.checkoutCTAText || 'Check out';
                return actionText;
            default:
                if (this.state.cartState.directToCheckout) {
                    actionText = cmsData.checkoutCTAText || 'Check out';
                    return actionText;
                }
                else {
                    return cmsData.goToCartCTAText || actionText;
                }
        }
    };
    // Hack: 472254
    PriceBarContainer.prototype.shouldEnableStickyButtons = function () {
        if (((this.state.cartState.dueMonthly && this.state.cartState.dueMonthly > 0) ||
            (this.state.cartState.dueOneTime && this.state.cartState.dueOneTime > 0) ||
            this.state.cartState.dueToday > 0)
            && location.pathname.indexOf('cart') === -1 &&
            location.pathname.indexOf('checkout') === -1 &&
            location.pathname.indexOf('/offers') === -1) {
            return true;
        }
        else {
            return this.state.cartState.readyToCheckout;
        }
    };
    PriceBarContainer.prototype.getPriceBarData = function () {
        var pbData = this.props.pbDataStore;
        var buttonEnabled;
        if (pbData) {
            buttonEnabled = pbData.readyToCheckout;
            return this.getPriceBarDataForLobs(pbData, buttonEnabled);
        }
        else {
            buttonEnabled = this.shouldEnableStickyButtons();
            return this.getPriceBarDataForLobs(this.state.cartState, buttonEnabled);
        }
    };
    PriceBarContainer.prototype.getPriceBarDataForLobs = function (cartState, buttonEnabled) {
        var feedUrl = CMSFeedMap.get(getCatalogDataType());
        var url = window.location.href;
        if (url && url.indexOf(RouteUrlTypes.CART) > -1 || url.indexOf(RouteUrlTypes.CHECKOUT) > -1) {
            feedUrl = CMSFeedMap.get(CatalogDataType.CARTCHECKOUT);
        }
        var cmsDataAttrName = feedUrl ? feedUrl.split('/idpcms/sales/buy/')[1] : null;
        var cmsPriceBarData = cmsDataAttrName ? CMS.get({}, cmsDataAttrName).content.priceBar : {};
        cmsPriceBarData = (cmsPriceBarData || {});
        var bbCmsData = cmsDataAttrName ? CMS.get({}, cmsDataAttrName).content : {};
        if (bbCmsData && bbCmsData.cart && bbCmsData.cart.broadbandCart &&
            bbCmsData.cart.broadbandCart.cartSummary) {
            bbCmsData = bbCmsData.cart.broadbandCart.cartSummary;
        }
        else {
            bbCmsData = {};
        }
        var actionText = this.getActionText(cmsPriceBarData, cartState);
        var dueOneTimeCharge = 0;
        if (this.state.hideOneTimeCharges || checkoutUtils.isPrepaidFlowType()) {
            dueOneTimeCharge = undefined;
        }
        else if (cartState.dueOneTime) {
            dueOneTimeCharge = cartState.dueOneTime;
        }
        var todayAmount = (cartState.enablepriceBarZeroAmount && cartState.dueToday === 0) ? cartState.dueToday.toFixed(2) : cartState.dueToday;
        var monthlyAmount = (cartState.enablepriceBarZeroAmount && cartState.dueMonthly === 0) ? cartState.dueMonthly.toFixed(2) : cartState.dueMonthly;
        var showExcludedTaxContent = false;
        var taxLegalText = cmsPriceBarData.taxNoteText;
        var dueOneTimeChargesText = cmsPriceBarData.dueOneTimeChargestText;
        var dueMonthlyChargesText = cmsPriceBarData.dueMonthlyText;
        var todayPriceText = cmsPriceBarData.dueTodayText;
        if (bbCmsData && cartUtils.isSpecialBBPricing(bbCmsData.specialHsiaOffers)) {
            dueMonthlyChargesText = cmsPriceBarData.bbPricingDueMonthlyText || '';
            dueOneTimeChargesText = cmsPriceBarData.bbPricingDueOneTimeChargesText || '';
            taxLegalText =
                cartUtilityFunction.IsBroadbandInCart() ?
                    cmsPriceBarData.bbDTVNTaxNoteText : cartUtilityFunction.IsBroadbandInCart()
                    ? cmsPriceBarData.bbDTVSTaxNoteText :
                    cartUtilityFunction.IsBroadbandInCart() ? cmsPriceBarData.bbTaxNoteText : taxLegalText;
        }
        else if (isPrepaidTaxCalculated()) {
            taxLegalText = cmsPriceBarData.prepaidTaxLabel || '';
        }
        else if (checkoutUtils.isStandaloneDTVSInCart()) {
            taxLegalText = cmsPriceBarData.trueFeesStandAloneTaxLegal;
            dueOneTimeChargesText = cmsPriceBarData.trueFeesOneTimeChargesText;
            dueMonthlyChargesText = cmsPriceBarData.trueFeesMonthlyChargesText;
        }
        else if (cartUtilityFunction.IsAccessoryOnlyInCart()) {
            taxLegalText = cmsPriceBarData.accTaxNoteLabel || 'Plus tax';
            showExcludedTaxContent = onCartIsTaxCalculated() ? false : true;
        }
        this.showBottomPriceBar = false;
        var _cartRedesignSupress = this.stateManager.get('CART', 'cartRedesignSupressCart');
        if ((_cartRedesignSupress === null || _cartRedesignSupress === void 0 ? void 0 : _cartRedesignSupress.isSupressed) && isIxpCheckoutFeatureEnabled('svc-display-pricing-summary') &&
            !cartUtilityFunction.IsAccessoryOnlyInCart() && !checkoutUtils.isPrepaidFlowType()) {
            this.showBottomPriceBar = true;
        }
        return {
            buttonData: {
                color: ButtonColor.EMERALDGREEN,
                disableToolTipText: cartState.disabledButtonToolTipText,
                enabled: buttonEnabled,
                showLoader: this.state.isApiCallInProgress,
                text: actionText,
            },
            decimalPoints: 2,
            excludedTaxLabel: this.showBottomPriceBar ? '*Plus taxes and fees' : taxLegalText,
            monthlyPrice: this.showBottomPriceBar ? monthlyAmount :
                (cartUtilityFunction.IsAccessoryOnlyInCart() || cartUtils.enableBillComponent()) ? undefined : monthlyAmount,
            monthlyPriceLabel: (this.state.isBBTVinCart && !checkoutUtils.IsEmployeeOfferAvailable()) ?
                cmsPriceBarData.dueFirstMonthText : dueMonthlyChargesText,
            oneTimeCharge: this.showBottomPriceBar ? undefined :
                (cartUtilityFunction.IsAccessoryOnlyInCart() || cartUtils.enableBillComponent()) ? undefined : dueOneTimeCharge,
            oneTimeChargeLabel: dueOneTimeChargesText,
            showExcludedTaxLabel: showExcludedTaxContent,
            todayPrice: this.showBottomPriceBar ? todayAmount : cartUtils.enableBillComponent() ? undefined : todayAmount,
            todayPriceLabel: todayPriceText,
        };
    };
    PriceBarContainer.prototype.onPriceClick = function () {
        var _this = this;
        window.sessionStorage.removeItem('WIRELESS:currentcontext');
        window.sessionStorage.removeItem('CART:editLinkUrl');
        window.sessionStorage.removeItem('CHECKOUT:emptyCart');
        window.sessionStorage.removeItem('CART:emptyCart');
        var newUpSellCartApiEnabled = this.stateManager.get('WIRELESS', 'newUpSellCartApi');
        var urlPath = history.location.pathname;
        var arrayUrl = urlPath.split('/');
        switch (arrayUrl[1]) {
            case 'checkout':
                if (!this.state.isApiCallInProgress) {
                    this.onSubmitOrderDetails();
                }
                break;
            case 'cart':
                this.resetButtonState();
                this.resetPBData();
                this.preChecksForCheckoutActions();
                break;
            default:
                if (newUpSellCartApiEnabled === null || newUpSellCartApiEnabled === void 0 ? void 0 : newUpSellCartApiEnabled.value) {
                    this.getNewUpsellApiData()
                        .then(function (res) {
                        _this.loader.hideLoader();
                        _this.stateManager.set('catalogResponse', {});
                    })
                        .catch(function (e) {
                        _this.onPriceClick();
                    });
                }
                else if (this.state.cartState.directToCheckout) {
                    this.stateManager.set('skipCartContainer', { value: true });
                    this.resetButtonState();
                    this.resetPBData();
                    this.preChecksForCheckoutActions();
                }
                else {
                    this.resetButtonState();
                    this.resetPBData();
                    this.stateManager.set('startShopping', { startShopping: false });
                    history.push('/cart');
                }
                // in wireless if Upsell offer is available then it will redirect to upsell page otherwise cart page
                var wirelessUrl = (newUpSellCartApiEnabled === null || newUpSellCartApiEnabled === void 0 ? void 0 : newUpSellCartApiEnabled.value) ? UPSELL_INTERSTITAL_PAGE_URL : BUY_CART_PAGE_URL;
                var linkUrl = this.state.cartState.directToCheckout ? CHECKOUT_PAGE_URL : wirelessUrl;
                if (!this.state.cartState.directToCheckout) {
                    var addData2 = {
                        additionalData: {
                            linkDestinationUrl: this.constructFullUrl(linkUrl),
                            linkName: buttonText,
                            linkPosition: LinkPositionDataKeysOptions.FOOTER,
                        },
                        eventAction: 'linkClick',
                        eventCode: 'Link_Click',
                    };
                    ReportingGateway.sendReportingEvent(addData2);
                    break;
                }
        }
    };
    PriceBarContainer.prototype.showACPVerificationModal = function () {
        var feedUrl;
        var url = window === null || window === void 0 ? void 0 : window.location.href;
        if (url && url.indexOf(RouteUrlTypes.CART) > -1 || url.indexOf(RouteUrlTypes.CHECKOUT) > -1) {
            feedUrl = CMSFeedMap.get(CatalogDataType.CARTCHECKOUT);
        }
        var cmsDataAttrName = feedUrl ? feedUrl.split('/idpcms/sales/buy/')[1] : null;
        var cmsPriceBarData = cmsDataAttrName ? CMS.get({}, cmsDataAttrName).content.priceBar : {};
        return (React.createElement(Modal, { testId: getTestId('BROADBAND', 'ACP', 'modal'), options: {
                center: true,
                className: { modalContentClass: styles.acpVerificationModal },
                show: this.state.showACPModal,
                showClose: true,
                size: ModalSizes.MEDIUM,
            }, events: { onClose: this.onClose } },
            React.createElement("div", { className: styles.acpContainer },
                React.createElement("h3", { className: styles.acpModalTitle }, (cmsPriceBarData === null || cmsPriceBarData === void 0 ? void 0 : cmsPriceBarData.headerMsg) || 'Your ACP benefit is missing'),
                React.createElement("p", { className: styles.modalText }, (cmsPriceBarData === null || cmsPriceBarData === void 0 ? void 0 : cmsPriceBarData.bodyMsg) ||
                    'You\'ll have to reapply your ACP benefit to your order. ' +
                        'Please go back and complete the steps to let us know you were approved. ' +
                        'When you\'re done, come back to finish your order.'),
                React.createElement("div", { className: styles.acpButtonStyle },
                    React.createElement(Button, { testId: getTestId('BROADBAND', 'ACP', 'benifit'), events: { onClick: this.onApplyBenifit }, data: { text: (cmsPriceBarData === null || cmsPriceBarData === void 0 ? void 0 : cmsPriceBarData.goBackCTAMsg) || goBackApplyBenefitBtnText }, options: {
                            className: styles.acpButton,
                            type: ButtonType.PRIMARY,
                        } })),
                React.createElement("div", { className: styles.acpButtonStyle },
                    React.createElement(Button, { testId: getTestId('BROADBAND', 'ACP', 'checkout'), events: { onClick: this.onCheckOut }, data: { text: (cmsPriceBarData === null || cmsPriceBarData === void 0 ? void 0 : cmsPriceBarData.checkoutCTAMsg) || checkoutWithoutBenefitBtnText }, options: { className: styles.acpButton, type: ButtonType.GHOST } })))));
    };
    PriceBarContainer.prototype.onClose = function () {
        this.setState({ showACPModal: false });
        this.resetButtonState(true);
        this.resetPBData(undefined, true);
        reportPageLoad(false);
    };
    PriceBarContainer.prototype.onApplyBenifit = function () {
        cartUtils.setAcpCustomerPropsInSessionStorage('FIBER');
        this.setState({ showACPModal: false });
        var acpVerificationFormUrl = location.protocol + "//" + location.host + "/acp/verification";
        this.reportingService.fireLinkClickEvent(goBackApplyBenefitBtnText, acpVerificationFormUrl);
        var acpURL = "" + location.host === 'idse2.dev.att.com:10081'
            ? location.protocol + "//" + location.host + "/microsites/v1/acp/verification"
            : acpVerificationFormUrl;
        window.location.href = acpURL;
    };
    PriceBarContainer.prototype.onCheckOut = function () {
        this.setState({ showACPModal: false });
        this.reportingService.fireLinkClickEvent(checkoutWithoutBenefitBtnText, CHECKOUT_PAGE_URL);
        this.state.cartState.directToCheckout
            ? this.directCheckOutAction(true)
            : this.postCartSubmitAction(true);
        history.push('/checkout/checkoutview');
        this.state.cartState.directToCheckout
            ? this.directCheckOutAction(false)
            : this.postCartSubmitAction(false);
    };
    PriceBarContainer.prototype.reportAcpModalPageLoad = function () {
        var addData = {
            additionalData: __assign({ url: '/buy/cart/internet/acpmissing/modal' }, setFlowCodeandProductTypeValues()),
            eventAction: 'pageLoad',
            eventCode: 'Page_Load',
        };
        ReportingGateway.sendReportingEvent(addData);
        fireSystemEvent(false);
    };
    // tslint:disable-next-line:no-any
    PriceBarContainer.prototype.fetchOnDeviceEncryptToken = function (targetIMEI) {
        var request = {
            source: 'EAP',
            ratePlanFlag: 'F',
            statusCodes: [
                { statusCode: '400',
                    statusTimestamp: (new Date()).toISOString(),
                    statusMessage: 'Cancel Order',
                },
            ],
            targetIMEI: targetIMEI,
        };
        var isEapEdsActivationEncrypttoken = isIxpCheckoutFeatureEnabled('svc-eap-eds-watchactivation-encrypttoken');
        var postEncryption = isEapEdsActivationEncrypttoken
            ? this.checkoutApi.postEdsEncriptionForActivationEAP(request)
            : this.checkoutApi.postEdsEncriptionForActivation(request);
        return postEncryption.then(function (response) {
            console.log("postEncryptionResp", response);
            if (response && response.content) {
                return response;
            }
            else {
                return Promise.reject.bind(Promise);
            }
        }).then(function (result) {
            console.log('postEncryptionResp1', result);
            return result;
        }).catch(function (reason) {
            console.log('postEncryptionRespcatch', reason);
            Promise.reject(reason);
        });
    };
    PriceBarContainer.prototype.eapCancelButtonHandler = function () {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var wlsPostpaid, returnURL, targetIMEI, error_2;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        wlsPostpaid = JSON.parse(sessionStorage.getItem('wlsPostpaid'));
                        if (!(wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData)) {
                            wlsPostpaid = JSON.parse(sessionStorage.getItem('CHECKOUT:wlsPostpaidAndroid'));
                        }
                        returnURL = ((_a = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _a === void 0 ? void 0 : _a.eapFlow) && ((_c = (_b = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _b === void 0 ? void 0 : _b.eapFlow) === null || _c === void 0 ? void 0 : _c.returnURL);
                        targetIMEI = ((_d = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _d === void 0 ? void 0 : _d.eapFlow) && ((_f = (_e = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _e === void 0 ? void 0 : _e.eapFlow) === null || _f === void 0 ? void 0 : _f.targetIMEI);
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchOnDeviceEncryptToken(targetIMEI)
                                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                                var formData, form, key, input;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    console.log('encryptionResp', resp);
                                    formData = {
                                        prToken: (_a = resp === null || resp === void 0 ? void 0 : resp.content) === null || _a === void 0 ? void 0 : _a.handoffToken,
                                        responseToken: (_b = resp === null || resp === void 0 ? void 0 : resp.content) === null || _b === void 0 ? void 0 : _b.responseToken,
                                    };
                                    form = document.createElement('form');
                                    form.method = 'POST';
                                    form.action = returnURL;
                                    for (key in formData) {
                                        input = document.createElement('input');
                                        input.name = key;
                                        input.value = formData[key];
                                        input.type = 'hidden';
                                        form.appendChild(input);
                                    }
                                    document.body.appendChild(form);
                                    form.submit();
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2:
                        _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _g.sent();
                        console.log('encryptionRespcatch', error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PriceBarContainer.prototype.render = function () {
        var pricebarData = this.getPriceBarData();
        var showPriceBar = this.getShowPriceBar(pricebarData);
        var newUpsellPageDetails = window.sessionStorage.getItem('appShell:upSellPageDetails');
        // tslint:disable-next-line:no-any
        var showOnDeviceWearablePPU = this.stateManager.get('CHECKOUT', 'showOnDeviceWearablePPU');
        if (!isEmptyObject(newUpsellPageDetails)) {
            return null;
        }
        var wrapperClass = [offerStyles.stickyBarWrapper];
        if (this.props.className) {
            wrapperClass.push(this.props.className);
        }
        var pbData = this.props.pbDataStore;
        var buttonLabel = pbData && pbData.buttonLabel;
        var urlPath = history.location.pathname;
        var arrayUrl = urlPath.split('/');
        var iconicStyle = (this.isExpressUpgrade && !checkoutUtils.isPrepaidFlowType()) ? 'iconic' : '';
        iconicStyle = (buttonLabel && buttonLabel.toLowerCase().indexOf('apple pay') > -1)
            ? (this.isExpressUpgrade ? 'newapplepayiconic' : 'oldapplepayiconic') : iconicStyle;
        if (this.showBottomPriceBar) {
            iconicStyle = 'checkout';
        }
        return (React.createElement("div", { className: offerStyles[iconicStyle + "stickyBarContainer"] },
            React.createElement("div", { className: wrapperClass.join(' ') },
                React.createElement("div", { className: offerStyles.stickyBarShadow }),
                !!(showOnDeviceWearablePPU === null || showOnDeviceWearablePPU === void 0 ? void 0 : showOnDeviceWearablePPU.isWearable) &&
                    (arrayUrl[1] === 'checkout' || arrayUrl[2] === 'checkout') &&
                    React.createElement("div", null,
                        React.createElement(PriceBar, { testId: getTestId('Common', 'PriceBar'), data: pricebarData, events: { onButtonClick: this.onPriceClick } }),
                        React.createElement("div", { className: offerStyles.cancelOrder },
                            React.createElement(Button, { testId: getTestId('Link', 'cancelorder'), events: { onClick: this.eapCancelButtonHandler }, data: { text: 'Cancel order' }, options: {
                                    className: styles.cancelButton,
                                    type: ButtonType.PRIMARY,
                                } }))),
                !((showOnDeviceWearablePPU === null || showOnDeviceWearablePPU === void 0 ? void 0 : showOnDeviceWearablePPU.isWearable) &&
                    (arrayUrl[1] === 'checkout' || arrayUrl[2] === 'checkout')) &&
                    React.createElement(PriceBar, { testId: getTestId('Common', 'PriceBar'), data: pricebarData, events: { onButtonClick: this.onPriceClick } })),
            this.showACPVerificationModal()));
    };
    PriceBarContainer.prototype.processOrder = function (applePayData) {
        var _this = this;
        var pbData = this.props.pbDataStore;
        this.stateManager.set('submitOrder', { orderSubmitted: true });
        this.resetPBData(applePayData ? pbData.buttonLabel : undefined);
        this.resetButtonState(true);
        this.state.isApiCallInProgress = true;
        this.checkoutApi.postOrderSubmit(applePayData)
            .then(function (data) {
            _this.setState({ isApiCallInProgress: false });
            if (data.error) {
                if (data.error.errorId === 'inline') {
                    _this.stateManager.set('submitOrder', { orderSubmitted: false });
                }
                else {
                    _this.resetPBData(applePayData ? pbData.buttonLabel : undefined);
                    _this.resetButtonState();
                }
            }
            if (data.content
                && data.content.order) {
                _this.updateGNAVCart();
                var redirectUrl = '/buy/thankyou';
                if (checkoutUtils === null || checkoutUtils === void 0 ? void 0 : checkoutUtils.purchaseorderThankyouRedirection()) {
                    redirectUrl = '/buy/purchaseorder/thankyou';
                }
                window.location.href = redirectUrl + _this.getOrderConfirmURL();
            }
        }).catch(function (err) {
            _this.setState({ isApiCallInProgress: false });
            _this.stateManager.set('submitOrderError', { orderSubmitError: true });
        });
    };
    PriceBarContainer.prototype.getShowPriceBar = function (pricebarData) {
        var total = 0;
        var pbData = this.props.pbDataStore;
        if (pricebarData) {
            total = (pricebarData.todayPrice ? parseFloat('' + pricebarData.todayPrice) : 0) +
                (pricebarData.monthlyPrice ? parseFloat('' + pricebarData.monthlyPrice) : 0) +
                (pricebarData.oneTimeCharge ? parseFloat('' + pricebarData.oneTimeCharge) : 0);
        }
        return pbData && pbData.enablepriceBarZeroAmount ? (total >= 0) : (total > 0);
    };
    PriceBarContainer.prototype.getTotalPrice = function (cartState) {
        var total = 0;
        if (cartState) {
            total = (cartState.dueToday ? parseFloat('' + cartState.dueToday) : 0) +
                (cartState.dueMonthly ? parseFloat('' + cartState.dueMonthly) : 0) +
                (cartState.dueOneTime ? parseFloat('' + cartState.dueOneTime) : 0);
        }
        return total;
    };
    PriceBarContainer.prototype.preChecksForCheckoutActions = function () {
        var acpCustomerStatus = cartUtils.getAcpCustomerStatusFromSessionStorage();
        var eligibilityIndicator = (acpCustomerStatus || {}).eligibilityIndicator;
        if (checkoutUtils.isLoginRequiredonCart() && typeof window !== undefined) {
            var ulr = checkoutUtils.getauthenticatedPersistantLoginURL();
            var addData = {
                additionalData: {
                    linkDestinationUrl: ulr,
                    linkName: 'Check out',
                    linkPosition: LinkPositionDataKeysOptions.BODY,
                },
                eventAction: 'linkClick',
                eventCode: 'Link_Click',
            };
            ReportingGateway.sendReportingEvent(addData);
            window.location.href = ulr;
        }
        else if (cartUtils.acpVerification() && (!acpCustomerStatus || eligibilityIndicator === true)) {
            // show the modal if there is no sessionStorage item or if there is sessionStorage item & eligibilityIndicator is true
            this.setState({ showACPModal: true });
            this.resetButtonState(true);
            this.reportAcpModalPageLoad();
        }
        else {
            this.state.cartState.directToCheckout ? this.directCheckOutAction(true) : this.postCartSubmitAction(true);
            history.push('/checkout/checkoutview');
            this.state.cartState.directToCheckout ? this.directCheckOutAction(false) :
                this.postCartSubmitAction(false);
            // Commenting out below code as Login is now not required for Checkout but might be introduced again
            /* this.checkoutApi.getLoginRequiredOrNot()
                .then((data) => {
                    if (data.content && data.content.payload &&
                        data.content.payload.showLoginPanel) {
                        history.push('/login?&redirectURL=/checkout/checkoutview');    // temp hiding login
                    } else {
                        history.push('/checkout/checkoutview');
                    }
                    this.state.cartState.directToCheckout ? this.directCheckOutAction(false) : this.postCartSubmitAction(false);
                }).catch((err) => {
                    history.push('/checkout/checkoutview');
                    this.state.cartState.directToCheckout ? this.directCheckOutAction(false) : this.postCartSubmitAction(false);
                }); */
        }
    };
    PriceBarContainer.prototype.removePathfromURL = function (url, path) {
        if (url && url.indexOf(path) > -1) {
            var urlSplitArr = url.split(path);
            if (urlSplitArr && urlSplitArr[1]) {
                return urlSplitArr[1];
            }
            else {
                return '';
            }
        }
        else {
            return url;
        }
    };
    PriceBarContainer.prototype.postCartSubmitAction = function (isRequest) {
        var addData1 = {
            additionalData: {
                errorType: ErrorTypeOption.Success_Admit,
                linkDestinationUrl: this.constructFullUrl(CHECKOUT_PAGE_URL),
                linkName: 'Checkout',
                linkPosition: LinkPositionDataKeysOptions.BODY,
                statusCode: isRequest ? '-2' : '0',
                statusMessage: isRequest ? '' : 'success',
                successFlag: isRequest ? SuccessFlags.UNKNOWN : SuccessFlags.SUCCESSFUL,
            },
            eventAction: isRequest ? EventActions.FORM_SUBMIT : EventActions.FORM_RESPONSE,
            eventCode: 'DS_Cart_Submit',
        };
        ReportingGateway.sendReportingEvent(addData1);
    };
    PriceBarContainer.prototype.directCheckOutAction = function (isRequest) {
        var addData1 = {
            additionalData: {
                errorType: ErrorTypeOption.UNKNOWN,
                linkDestinationUrl: this.constructFullUrl(CHECKOUT_PAGE_URL),
                linkName: 'Checkout',
                linkPosition: LinkPositionDataKeysOptions.BODY,
                statusCode: isRequest ? '-2' : '0',
                statusMessage: isRequest ? '' : 'success',
                successFlag: isRequest ? SuccessFlags.UNKNOWN : SuccessFlags.SUCCESSFUL,
            },
            eventAction: isRequest ? EventActions.FORM_SUBMIT : EventActions.FORM_RESPONSE,
            eventCode: 'DS_Proceed_To_Checkout_Submit',
        };
        ReportingGateway.sendReportingEvent(addData1);
    };
    PriceBarContainer.prototype.getOrderConfirmURL = function () {
        var finalURLData = this.stateManager.get('CHECKOUT', 'orderSubmitURL');
        return (finalURLData && finalURLData.finalURL) ? finalURLData.finalURL : '';
    };
    return PriceBarContainer;
}(React.Component));
export { PriceBarContainer };
var mapStateToProps = function (state) {
    if (state && state.appShell) {
        return {
            baseUrlStore: state.appShell.baseURL,
            pbDataStore: state.appShell.pbData,
        };
    }
    return {};
};
var PriceBarContainerWithStore = withStore(mapStateToProps)(PriceBarContainer);
export default PriceBarContainerWithStore;
//# sourceMappingURL=PriceBar.container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBar.container.js
// module id = 1964
// module chunks = 8